const setTokens = ({ Token, email, name, role, isAuthenticated }) => {
    localStorage.setItem('email', JSON.stringify(email));
    localStorage.setItem('Token', JSON.stringify(Token));
    localStorage.setItem('name', JSON.stringify(name));
    localStorage.setItem('role', JSON.stringify(role));
    localStorage.setItem('isAuthenticated', isAuthenticated);
};

const removeTokens = () => {
    localStorage.removeItem('name');
    localStorage.removeItem('Token');
    localStorage.removeItem('email');
    localStorage.removeItem('role');
    localStorage.removeItem('isAuthenticated');
};
const getToken = () => localStorage.getItem('Token');
const getUser = () => localStorage.getItem('email');
const getRole = () => localStorage.getItem('role');
const getName = () => localStorage.getItem('name');
const getIsAuthenticated = () => localStorage.getItem('isAuthenticated');
const setUser = (user) => localStorage.setItem('user_Name', JSON.stringify(user));

module.exports = { setTokens, removeTokens, getToken, getUser, getRole, getName, setUser, getIsAuthenticated };